module.exports = __webpack_public_path__ + "static/media/phone.bc615697.svg";